import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ssf-example',
  template: `
    <p>
      ssf-example works!
    </p>
  `,
  styles: []
})
export class SsfExampleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
